import React, { useEffect, useState } from "react";
import { FormGroup, Page, PendingButton, required, SubmitButton, } from "components/common";

import { actions, Control, Errors } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import { useForm } from "hooks";
import Select from "react-select";
import { Multiselect } from "multiselect-react-dropdown";
import { Trans } from "react-i18next";
import { Table } from "reactstrap";
import { filter } from "lodash";
import { validationMessage } from "constants/validationMsg";
import { isCurrency } from "../../../services/util";
import BackButton from "../../../components/refactoring/BackButton"
import { XeroClient } from "services";
import { HistoryAndNotes } from "components";

export const convertTypes = (types, t) => {
  let amounts = []
  for (let i = 0; i < types.length; i++) {
    let amt = types[i]
    if (amt.id === "FXD") {
      amounts.push({ ...amt, text: t('Fixed') })
    } else {
      amounts.push({ ...amt, text: t('Percentage') })
    }
  }
  return amounts
}

export const EditProvision = ({
  client,
  payroll,
  t,
  url = "provisions",
  model = "local",
  history,
  match,
}) => {
  let newDeductions = [];
  const { id } = match.params;
  const multiSelectStyle = {
    chips: { background: '#72B566' },
  }
  const { dispatch, setValue, value, Form, save, loaded, load, getTitle } =
    useForm({
      model,
    });
  const [amountTypesOptions, setAmountTypesOptions] = useState([]);
  const [allowanceRulesOptions, setAllowanceRulesOptions] = useState([]);
  const [deductionOptions, setDeductionOptions] = useState([]);
  const [deductions, setDeductions] = useState([]);

  const [contactListOption, setContactListOption] = useState([]);


  const onMount = async () => {
    const amountTypes = await client.get("amount_types").get("data");
    const allowanceRules = await payroll.get("allowance_rules_options").get("data");
    const DeductionRules = await payroll.get("deduction_rules_options").get("data");
    setAmountTypesOptions(amountTypes);
    setAllowanceRulesOptions(allowanceRules);
    setDeductionOptions(DeductionRules);

    const amounts = convertTypes(amountTypes, t)

    setAmountTypesOptions(amounts)

    // XeroClient().get('contacts?page=1&query=%7B%22page%22%3A1,%22raw%22%3A%22%22%7D&raw').then(({data}) => {
    XeroClient().get('contacts').then(({ data }) => {

      // console.log(data)

      const _data = data.map((x) => ({
        label: x.Name,
        value: x.ContactID,
      }));

      setContactListOption(_data);

    })
  };
  const handleSelectDeduction = (selectedList) => {
    setValue({ ...value, apply_to_deductions: selectedList });
  };

  const handleRemoveDeduction = (selectedList) => {
    setValue({ ...value, apply_to_deductions: selectedList });
  };

  const handleSelect = (selectedList) => {
    setValue({ ...value, apply_to_allowances: selectedList });
  };


  const handleRemove = (selectedList) => {
    setValue({ ...value, apply_to_allowances: selectedList });
  };
  useEffect(() => void onMount(), []);
  useEffect(() => {
    async function fetchData() {
      const item = await load(payroll, url, id, {
        description: "",
        amount: "",
        amount_type: "",
        amount_type_display: "",
        apply_to_employees: [
          { name: 'Foreigner', value: false },
          { name: 'Local', value: false }
        ],
        apply_to_allowances: [],
        apply_to_deductions: [],
      });
      setValue(item);
    }

    fetchData();
  }, [id]);

  async function onDeleteItem(deletedItem) {
    await payroll.delete(`${url}/${deletedItem}`);
    const availableDeduction = filter(value.deductions, (i) => i.id !== deletedItem)
    setDeductions(availableDeduction);
    setValue({ ...value, deductions: availableDeduction });
  }

  async function onSubmit(item) {
    item = {
      ...item,
      apply_to_allowances: item.apply_to_allowances.map((i) => i.id),
      apply_to_deductions: item.apply_to_deductions.map((i) => i.id),
    }
    try {
      dispatch(actions.setPending("local"));
      const savedData = await save(payroll, url, item).get("data");
      history.replaceUp();
      NotificationManager.success(t("Saved successfully"));
      if (newDeductions) {
        setDeductions(newDeductions);
        setValue({
          description: "",
          amount: "",
          amount_dedcution: "",
          amount_type: "",
          amount_type_display: "",
          apply_to_allowances: [],
          apply_to_deductions: [],
          apply_to_employees: [
            { name: 'Foreigner', value: false },
            { name: 'Local', value: false }
          ]
        });
      };
    } finally {
      dispatch(actions.setPending(model, false));
      dispatch(actions.setSubmitted("local"));
    }
  }

  const handleKeyUp = e => {
    if (e.target.value.trim().length == 0) e.target.value = e.target.value.trim();
  };

  if (!loaded) return null;
  return (
    <Page title={getTitle(id, "Provision")} className="inv-table inv-tabs mb-2">
      <BackButton />
      <Form
        className="mb-2"
        onSubmit={onSubmit}
        validators={{
          description: { required },
          amount: {
            required,
            isCurrency: (val) => isCurrency(val, { min: 0.01 }),
            max: (val) => { return !(val && (value.amount_type === 'PERC' && val > 100)) },
          },
          amount_type: { required },
        }}
      >
        <div className="row">
          <FormGroup label="Description *" model=".description" className="col-sm pb-2 pt-2">
            <Control.text
              model=".description"
              updateOn="blur"
              placeholder="Provision Description"
              onKeyUp={handleKeyUp} />
            <Errors
              className="form-text small text-danger"
              model=".description"
              show="touched"
              messages={{
                required: t(validationMessage.REQUIRED),
              }}
            />
          </FormGroup>
          <FormGroup label="Amount *" model=".amount" className="col-sm pb-2 pt-2">
            <Control.text model=".amount" updateOn="blur" onKeyUp={handleKeyUp}
              placeholder="Provision amount"
            />
            <Errors
              className="form-text small text-danger"
              model=".amount"
              show="touched"
              messages={{
                required: t(validationMessage.REQUIRED),
                isCurrency: (val) => val && t(validationMessage.MINIMUM_CURRENCY_VALUE),
                max: t(validationMessage.MAXIMUM_PERCENTAGE_VALUE),
              }}
            />
          </FormGroup>
          <FormGroup
            label="Amount Type *"
            model=".amount_type"
            addControlClass={false}
            className="col-sm pb-2 pt-2">
            <Control.text style={{ backgroundColor: '#F4F7FE' }}
              placeholder="Provision Amount Type"
              model=".amount_type"
              component={Select}
              options={amountTypesOptions.map((x) => ({ value: t(x.id), label: t(x.text) }))}
              simpleValue
              clearable={false}
              searchable={false}
            />
            <Errors
              className="form-text small text-danger"
              model=".amount_type"
              show="touched"
              messages={{
                required: t(validationMessage.REQUIRED),
              }}
            />
          </FormGroup>
        </div>
        <fieldset>
          <div className="row mx-1 mb-2">
            <div><Trans>Apply To</Trans></div>
            {value.apply_to_employees.map((i, indx) => (
              <FormGroup label={i.name} className="mx-2" check key={indx}>
                <Control.checkbox model={`.apply_to_employees[${indx}].value`} />
              </FormGroup>
            ))}
          </div>
        </fieldset>
        <fieldset>
          <div className="mx-1"><Trans>Apply Provision also To Allowance</Trans></div>
          <div className="row my-2">
            <FormGroup model=".amount" className="col-sm d-block pb-2 pt-2">
              <Multiselect
                options={allowanceRulesOptions} // Options to display in the dropdown
                selectedValues={value.apply_to_allowances} // Preselected value to persist in dropdown
                onSelect={handleSelect} // Function will trigger on select event
                onRemove={handleRemove} // Function will trigger on remove event
                displayValue="description" // Property name to display in the dropdown options
                closeOnSelect
                avoidHighlightFirstOption
                showCheckbox={true}
                style={multiSelectStyle}
                placeholder={t("Select")}
                emptyRecordMsg={t('No options available')}
              />
            </FormGroup>
          </div>
        </fieldset>
        <fieldset>
          <div className="mx-1"><Trans>Associated Deduction</Trans></div>
          <div className="row my-2">
            <FormGroup model=".amount_dedcution" className="col-sm d-block ">
              <Multiselect
                options={deductionOptions} // Options to display in the dropdown
                selectedValues={value.apply_to_deductions} // Preselected value to persist in dropdown
                onSelect={handleSelectDeduction} // Function will trigger on select event
                onRemove={handleRemoveDeduction} // Function will trigger on remove event
                displayValue="description" // Property name to display in the dropdown options
                closeOnSelect
                avoidHighlightFirstOption
                showCheckbox={true}
                style={multiSelectStyle}
                placeholder={t("Select")}
                emptyRecordMsg={t('No options available')}
              />
            </FormGroup>
          </div>
        </fieldset>

        <div className="row">
          <FormGroup
            label="Contact"
            model=".contact_id"
            addControlClass={false}
            className="col-sm mt-3" >
            <Control.text style={{ backgroundColor: '#F4F7FE' }}
              model=".contact_id"
              component={Select}
              options={contactListOption}
              simpleValue
              clearable={false}
              searchable={true}
            />

            {/* <Errors
                        className="form-text small text-danger"
                        model=".country"
                        show="touched"
                        messages={{
                          required: t("this field is required")
                        }}
                    /> */}
          </FormGroup>
        </div>

        <div className="mb-3 mt-4 text-right">
          <SubmitButton className="px-3 mr-0">{id === 'new' ? t("Add") : t("Save")}</SubmitButton>
        </div>
        {id === 'new' && deductions.length > 0 && (<hr />)}
      </Form>
      {id === 'new' && deductions.length > 0 && (<Table size="sm">
        <thead>
          <tr>
            <th>
              <Trans>Description</Trans>
            </th>
            <th>
              <Trans>Amount</Trans>
            </th>
            <th>
              <Trans>Amount Type</Trans>
            </th>
          </tr>
        </thead>
        <tbody>
          {deductions.map((i, idx) => (
            <tr key={i.id}>
              <td>
                {i.description}
              </td>
              <td>
                {i.amount}
              </td>
              <td>
                {i.amount_type_display}
              </td>
              <td className="text-right">
                <PendingButton
                  size="sm"
                  color="link"
                  onClick={() => {
                    onDeleteItem(i.id);
                  }}
                >
                  <span className="fa fa-trash text-danger" />
                </PendingButton>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>)}

      <hr />

      <HistoryAndNotes
        item={value}
        contentType={'provision'}
        client={client}
        t={t}
      />
    </Page>
  );
};

export default EditProvision;
